import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from '../ui/button';
import { Actions as ORGANISATIONACTIONS } from '../../store/actions/organisationActions';
import {
  getFirmId,
  isClientWorkingContext,
  shellHomePath,
  shellKind,
} from '../utils/managementShell';

/**
 * Persistent chrome when a consultant/WL (or CYF admin) is working inside a client org.
 */
const WorkingAsBanner = ({
  active,
  clientName,
  firmId,
  firmKind,
  organisations,
  updateOrganisation,
  getOrganisation,
}) => {
  const history = useHistory();
  if (!active || !firmId) return null;

  const backLabel = firmKind === 'whitelabel' ? 'Back to partner' : 'Back to firm';

  const handleBack = () => {
    const firm =
      organisations?.find((o) => o.id === firmId) ||
      ({ id: firmId });
    updateOrganisation(firm);
    localStorage.setItem('Organisation', firmId);
    getOrganisation();
    history.push(shellHomePath(firmKind || 'consultant'));
  };

  return (
    <div
      className='flex flex-wrap items-center justify-between gap-3 border-b border-border bg-info-bg px-4 py-2 text-sm'
      role='status'>
      <span className='font-medium text-foreground'>
        Working as {clientName || 'client'}
      </span>
      <Button size='sm' variant='outline' onClick={handleBack}>
        {backLabel}
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => {
  const org = state.organisation?.details;
  const profile = state.profile?.details;
  const active = isClientWorkingContext(state);
  const firmId = active ? getFirmId(org, profile) : null;
  const firmOrg =
    (state.admin?.organisations || []).find((o) => o.id === firmId) ||
    (state.organisation?.list || []).find((o) => o.id === firmId);
  const firmKind = firmOrg
    ? shellKind(firmOrg, profile)
    : org?.whiteLabelId && org.whiteLabelId !== '0'
      ? 'whitelabel'
      : 'consultant';

  return {
    active,
    clientName: org?.name || org?.accountName,
    firmId,
    firmKind,
    organisations: [...(state.admin?.organisations || []), ...(state.organisation?.list || [])],
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateOrganisation: (org) => dispatch(ORGANISATIONACTIONS.updateOrganisation(org)),
  getOrganisation: () => dispatch(ORGANISATIONACTIONS.getOrganisation()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkingAsBanner);
